import type { ApiPressBoard, PressBoard } from '@api/types/pressBoard';

const adaptPressBoard = (data: ApiPressBoard): PressBoard => {
  return {
    id: data.id || '',
    timestamp: data.timestamp ?? null,
    pressSelections: (data.pressSelections || []).map(selection => ({
      publication: selection.publication || '',
      journalist: selection.journalist ?? null,
      selection: (selection.selection || []).map(item => ({
        rank: item.rank || 0,
        runnerNumber: item.runnerNumber ?? null,
      })),
      ranking: selection.ranking
        ? {
            position: selection.ranking.position ?? 0,
            points: selection.ranking.points ?? 0,
          }
        : null,
    })),
    pressSummary: (data.pressSummary || []).map(item => ({
      rank: item.rank || 0,
      runnerNumber: item.runnerNumber ?? null,
      totalPoints: item.totalPoints ?? null,
      firstChoiceCount: item.firstChoiceCount ?? null,
      secondChoiceCount: item.secondChoiceCount ?? null,
      category: item.category ?? null,
    })),
  };
};

export { adaptPressBoard };
